import { render, staticRenderFns } from "./SameGroup.vue?vue&type=template&id=24dd0649&scoped=true"
import script from "./SameGroup.vue?vue&type=script&lang=js"
export * from "./SameGroup.vue?vue&type=script&lang=js"
import style0 from "./SameGroup.vue?vue&type=style&index=0&id=24dd0649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd0649",
  null
  
)

export default component.exports